import React from 'react';
import styles from './Typography.scss';
export const Text = ({ size = 'medium', children, bold, color, transform, secondary, }) => {
    const style = color ? { color } : {};
    if (transform) {
        style.textTransform = transform;
    }
    return (React.createElement("span", { className: `${styles.text} ${styles[size]} ${bold ? styles.bold : ''} ${secondary ? styles.secondary : ''}`, style: style }, children));
};
export const Title = ({ size = 'medium', children, bold }) => {
    return (React.createElement("span", { className: `${styles.text} ${styles.title} ${styles[size]} ${bold ? styles.bold : ''}` }, children));
};
//# sourceMappingURL=Typography.js.map